import React from 'react';
import { Box, Typography, List, ListItem, ListItemText, ListItemIcon, styled } from '@mui/material';
import ApartmentOutlined from '@mui/icons-material/ApartmentOutlined';
import AttachMoney from '@mui/icons-material/AttachMoney';
import PropertyFooterLayout from '../../../components/properties/PropertyFooterLayout';
import { useOutletContext, useNavigate } from 'react-router-dom';

const AnimatedListItemIcon = styled(ListItemIcon, {
  shouldForwardProp: (prop) => prop !== 'animated',
})<{ animated: boolean }>(({ animated }) => ({
  animation: animated ? 'bounce 0.6s' : 'none',
  '@keyframes bounce': {
    '0%': { transform: 'scale(1)' },
    '50%': { transform: 'scale(1.2)' },
    '100%': { transform: 'scale(1)' },
  },
}));

type PublishOutletContext = {
  handleNavigateToLocation: () => void;
  propertyType: string;
  setPropertyType: (propertyType: string) => void;
};

const PublishPropertyTypePage = () => {
  const { handleNavigateToLocation, propertyType, setPropertyType } = useOutletContext<PublishOutletContext>();
  const navigate = useNavigate();

  const progress = 40; 
  const step = 1;

  const handleItemClick = (type: string) => {
    setPropertyType(type);
  };

  const handleBack = () => {
    navigate(-1); 
  };

  const handleContinue = () => {
    if (propertyType) {
      handleNavigateToLocation(); 
    }
  };

  const types = [
    {
      name: 'Alquiler',
      description: 'Propiedades en alquiler.',
      icon: <ApartmentOutlined sx={{ fontSize: 40 }} />,
    },
    {
      name: 'Venta',
      description: 'Propiedades en venta.',
      icon: <AttachMoney sx={{ fontSize: 40 }} />,
    },
  ];

  return (
    <>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', height: '80vh' }}>
        {/* Título de la página */}
        <Typography variant="h4" gutterBottom sx={{ fontWeight: '500', textAlign: 'center', mb: 4 }}>
          Selecciona el tipo de propiedad
        </Typography>

        {/* Lista de categorías */}
        <Box sx={{ width: '50%', flexGrow: 1 }}>
          <List sx={{ width: '100%', height: '100%', overflowY: 'auto' }}>
            {types.map((type) => (
              <ListItem
                key={type.name}
                onClick={() => handleItemClick(type.name)}
                sx={{
                  height: 150,
                  backgroundColor: propertyType === type.name ? '#b2dfdb' : 'white',
                  '&:hover': {
                    boxShadow: '0 12px 24px rgba(0, 0, 0, 0.2)',
                    transform: 'translateY(-4px)',
                    backgroundColor: propertyType === type.name ? '#b2dfdb' : '#f5f5f5',
                  },
                  borderRadius: '8px',
                  border: propertyType === type.name ? '2px solid black' : '2px solid grey',
                  mb: 3, 
                  boxShadow: propertyType === type.name ? 6 : 2,
                  transition: 'background-color 0.3s ease, box-shadow 0.3s ease',
                }}
              >
                <AnimatedListItemIcon animated={propertyType === type.name}>
                  {type.icon}
                </AnimatedListItemIcon>
                <ListItemText
                  primary={<Typography variant="h6" sx={{ fontWeight: 'bold' }}>{type.name}</Typography>}
                  secondary={<Typography variant="body2">{type.description}</Typography>}
                />
              </ListItem>
            ))}
          </List>
        </Box>
        <PropertyFooterLayout
          progress={progress}
          step={step}
          onBack={handleBack}
          onContinue={handleContinue}
          isContinueDisabled={!propertyType} 
        />
      </Box>
    </>
  );
};

export default PublishPropertyTypePage;
